import { setupStringFormat } from "./string-util";

export const initAppHelperUtils = () => {
    setupStringFormat();
};
